import { useState } from "react";
import { dimensionalStage } from "../utils/constant";
import api from "../config/axiosConfig";
import {
  addBaseUrlToImages,
  renameSubpartsKey,
} from "../utils/utilityFunctions";

export default function useGetDataForReportPdfStage({
  rfiDetails,
  stagesDetails,
}) {
  const [basicDetails, setBasicDetails] = useState({});
  const [basicReportData, setBasicReportData] = useState([]);
  const [componentData, setComponentData] = useState([]);

  const getAllDetails = async (stageNumber) => {
    try {
      const getStageData = stagesDetails?.find(
        (stage) => stage?.stage_number === stageNumber
      );

      // Create basic details object
      const basicDetailsData = {
        "Project Title": rfiDetails?.project_title || "___",
        Model: rfiDetails?.rfi_model?.model_name || "___",
        "Job No": rfiDetails?.job_no || "___",
        "Serial No": rfiDetails?.serial_no || "___",
        "Dimensional Stage":
          dimensionalStage[rfiDetails?.dimensional_stage?.toLowerCase()] ||
          "___",
        "Assets Type": rfiDetails?.asset_type || "___",
        "KD Number": rfiDetails?.kd_number || "___",
        "WO Number": rfiDetails?.wo_number || "___",
        "QC Coordinator Remark": getStageData?.coordinator_remarks || "___",
        "QC Manager Remark": getStageData?.manager_remarks || "___",
      };

      // Create basic report data
      const basicReportDataObj = {
        inspector_name:
          `${rfiDetails?.qc_inspector?.first_name}  ${rfiDetails?.qc_inspector?.last_name}` ||
          "___",
        from:
          rfiDetails?.company_name || rfiDetails?.company_id || "Austin Engg.",
        date: rfiDetails?.creation_date?.split("T")[0],
        issued_revised_by: rfiDetails?.issued_by || "___",
        reviewed_by:
          `${rfiDetails?.production_coordinator?.first_name} ${rfiDetails?.production_coordinator?.last_name}` ||
          "___",
        approved_by:
          `${rfiDetails?.qc_manager?.first_name} ${rfiDetails?.qc_manager?.last_name}` ||
          "___",
      };

      // Get component data
      const componentDataAll = await getStageComponentData();
      const safeComponentData = Array.isArray(componentDataAll)
        ? componentDataAll
        : [];

      // Update state (for the template component)
      setBasicDetails(basicDetailsData);
      setBasicReportData([basicReportDataObj]);
      setComponentData(safeComponentData);

      // Return the data directly for immediate use
      return {
        success: true,
        data: {
          basicDetails: basicDetailsData,
          basicReportData: basicReportDataObj,
          componentData: safeComponentData,
        },
      };
    } catch (error) {
      console.error("Error in getAllDetails:", error);
      return {
        success: false,
        message: error.message || "Failed to get PDF data",
        data: null,
      };
    }
  };

  const getStageComponentData = async () => {
    try {
      const response = await api.get(`/api/rfi-components`, {
        params: {
          rfi_id: rfiDetails?.rfi_id,
          page: 1,
          perPage: 200,
        },
      });

      if (!response.data) {
        console.warn("No data received from API");
        return [];
      }

      const getDataInDesiredFormat = renameSubpartsKey(response.data);
      const dataArray = Array.isArray(getDataInDesiredFormat?.data)
        ? getDataInDesiredFormat.data
        : [];

      const baseUrl = `${process.env.REACT_APP_API_BASE_URL}/api/files`;
      const updatedData = addBaseUrlToImages(dataArray, baseUrl);

      return Array.isArray(updatedData) ? updatedData : [];
    } catch (error) {
      console.error("Error fetching component data:", error);
      return [];
    }
  };

  return {
    basicDetails,
    basicReportData,
    componentData,
    getAllDetails,
  };
}
